<template>
	<transition name="modal" class="VModal">
		<div class="modalDialog" v-if="showModal">
			<div class="modal-dialog modal-dialog-centered" :class="[typeClass]" role="document">
				<div class="outsider modal-content text-gray">
					<div class="modal-header" v-if="!$slots.header">
						<div class="modal-title font-size-12 font-size-sm-11" id="exampleModalCenterTitle"><slot name="title"></slot></div>
						<!-- <button @click="modalHide" type="button" class="close" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button> -->
					</div>
					<slot v-else name="header"></slot>
					<slot name="tabMenu">
					</slot>
					<div class="modal-body border-bottom">
						<div class="px-0 px-lg-3">
							<slot name="body">
							</slot>
						</div>
					</div>
					<div class="footer-modal">
						<div v-if="!$slots.footer">
							<div class="row px-0 px-lg-4 pb-1 pt-2 pt-lg-3">
								<div class="col-8 offset-2 col-md-6 offset-md-3 col-lg-2 offset-lg-8 text-center pb-2">
								</div>
								<div class="col-8 col-md-6 col-lg-2 offset-2 offset-md-3 offset-lg-0 text-center pb-2">
									<button @click="modalHide" class="btn btn-danger btn-block font-size-10"> <i class="fas fa-times mr-2"></i>TUTUP</button>
								</div>
							</div>
						</div>
						<div class="container-fluid" v-else>
							<slot name="footer" >
							</slot>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name:'VModal',
		data: () => ({
			showModal:false,
		}),
		props: {
			type:{
				type: String,
				default: ''
			}
		},
		methods:{
			modalShow(){
				this.showModal = true
			},
			modalHide() {
				this.showModal = false
			},
		},
		watch: {
			showModal: function() {
				if(this.showModal) {
					document.documentElement.style.overflow = 'hidden'
				} else {
					document.documentElement.style.overflow = 'auto';
				}
			}
		},
		computed:{
			typeClass() {
				switch (this.type) {
					case 'modal-xl':
					return 'modal-xl';
					default:
					return '';
				}
			},
		},
	}
</script>

<style>
.VModal{
	overflow-x: hidden;
	overflow-y: auto;
}
.modal-dialog{
	margin-top:0;
}
.modalDialog {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	z-index: 99999;
	-webkit-transition: opacity 100ms ease-in;
	-moz-transition: opacity 100ms ease-in;
	transition: opacity 100ms ease-in;
	pointer-events: auto;
}
.modalDialog:target {
	opacity: 1;
	pointer-events: auto;
}
.modalDialog .outsider {
	position: relative;
	margin: 3% auto;
	border-radius: 5px;
	background: #fff;
}
.modal-body {
	max-height: 65vh;
	/* overflow-y: auto; */
	overflow-x: hidden !important;
	overflow-y: auto !important;
}

@media (max-width: 1440px) {
	.modalDialog {
		overflow: hidden;
	}
	.modal-body {
		max-height: 60vh;
	}
}

@media (max-width: 768px) {
	.modalDialog {
		overflow: scroll;
	}
	.modal-body {
		max-height: 60vh;
	}
}

@media (max-width: 425px) {
	.modalDialog .outsider {
		width: 95%;
	}
}

@media (max-width: 320) {
	.modal-body {
		max-height: 55vh;
	}
}
</style>